import {Box, createTheme, ThemeProvider} from "@mui/material";
import {Route, BrowserRouter as Router, Routes, useLocation} from "react-router-dom";
import './App.css';
import ScrollToTop from "./scripts/ScrollToTop";
import LandingPage from "./pages/LandingPage/LandingPage";
import ProjectsPage from "./pages/SinglePages/ProjectsPage";
import EducationSubPage from "./pages/SubPage/EducationSubPage";
import ExperienceSubPage from "./pages/SubPage/ExperienceSubPage";
import LandingFooter from "./pages/LandingPage/components/LandingFooter";
import LandingHeader from "./pages/LandingPage/components/LandingHeader";
import ExperiencePage from "./pages/SinglePages/ExperiencePage";
import EducationPage from "./pages/SinglePages/EducationPage";
import ProjectSubPage from "./pages/SubPage/ProjectSubPage";
import { Analytics } from "@vercel/analytics/react"
import CvPage from "./pages/CvPage";

function AppContent() {
    const location = useLocation();
    const isCvRoute = location.pathname === "/cv" || location.pathname.startsWith("/cv/");

    return (
        <>
            <Analytics/>
            <div className="App">
                <ScrollToTop/>
                <Box className={isCvRoute ? undefined : "gradient-bg"} sx={{minHeight: '100dvh', backgroundColor: '#1e1e1e' }}>
                    {!isCvRoute && <LandingHeader/>}
                    <Routes>
                        <Route path="/" element={<LandingPage/>}/>
                        <Route path="/cv/*" element={<CvPage/>}/>
                        <Route path="/projects" element={<ProjectsPage/>}/>
                        <Route path="/experience" element={<ExperiencePage/>}/>
                        <Route path="/education" element={<EducationPage/>}/>
                        <Route path="/projects/:id" element={<ProjectSubPage />}/>
                        <Route path="/education/:id" element={<EducationSubPage />}/>
                        <Route path="/experience/:id" element={<ExperienceSubPage />}/>

                        <Route path="*" element={<LandingPage />}/>
                    </Routes>
                    {!isCvRoute && <LandingFooter/>}
                </Box>
            </div>
        </>
    );
}

function App() {
    const theme = createTheme();

    return (
        <>
            <ThemeProvider theme={theme}>
                <Router>
                    <AppContent/>
                </Router>
            </ThemeProvider>
        </>
    );
}

export default App;
